import { MainLayoutContext } from "@/layouts/mainLayout";
import { useEffect, useRef } from "react";
import { useOutletContext } from "react-router-dom";
import { REACT_APP_CMS_FE_DOMAIN } from "@/config";

interface SwiftEmbedConfig {
  node: string;
  tenantDomain: string;
  tenantId: string;
  platform: string;
}

declare global {
  interface Window {
    __SWIFT_EMBED_CONFIG__?: SwiftEmbedConfig;
  }
}

export default function ProfilePage() {
  // Get data from MainLayout via Outlet context
  const { tenantDomain, tenantId } = useOutletContext<MainLayoutContext>();

  const widgetContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Set style on widget container
    if (widgetContainerRef.current) {
      widgetContainerRef.current.setAttribute(
        "style",
        "display: block !important;"
      );
    }

    // Add style tag
    const style = document.createElement("style");
    style.textContent = `
      div:has(> .embed) {
        height: 100% !important;
      }
    `;
    document.head.appendChild(style);

    // Configure theme embed
    const config = {
      node: "widget-container",
      tenantDomain: tenantDomain || "",
      tenantId: tenantId || "",
      platform: "generic",
    };

    // Expose config to bootstrap script
    window.__SWIFT_EMBED_CONFIG__ = config;

    // Load bootstrap script
    const scriptURL = `${REACT_APP_CMS_FE_DOMAIN}/script-build/theme-bootstrap.js`;
    const script = document.createElement("script");
    script.src = scriptURL;
    script.async = true;
    script.onerror = function () {
      console.error("[SwiftTheme] Failed to load bootstrap script");
      const container = document.getElementById("widget-container");
      if (container) {
        container.innerHTML =
          '<div style="text-align:center;padding:2rem;color:red;">Failed to load theme. Please check your connection.</div>';
      }
    };
    (document.head || document.body).appendChild(script);

    // Cleanup function
    return () => {
      // Remove style
      const existingStyle = document.querySelector("style");
      if (
        existingStyle &&
        existingStyle.textContent?.includes("div:has(> .embed)")
      ) {
        existingStyle.remove();
      }

      // Remove script
      const existingScript = document.querySelector(
        `script[src="${scriptURL}"]`
      );
      if (existingScript) {
        existingScript.remove();
      }

      // Clean up config
      if (window.__SWIFT_EMBED_CONFIG__) {
        delete window.__SWIFT_EMBED_CONFIG__;
      }
    };
  }, [tenantDomain, tenantId]);

  return (
    <>
      <div id="widget-container" ref={widgetContainerRef}></div>
    </>
  );
}
